module.exports = __webpack_public_path__ + "img/separator11.33abcaa5.svg";